import SchoolOptionsRoute from 'linced-app/routes/school-options';

export default class HeroSupportRoute extends SchoolOptionsRoute {}
